import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { breakpoints } from '../assets/styles/mediaBreakpoints'
import { PillButton } from '../components/common/stand_alone/pillButton'
import heroesData from '../assets/data/superheroes.json'
import { Hero } from '../types/hero'
import { NavLink } from 'react-router-dom'

const SuperheroesPage = () => {
  const [heroes, setHeroes] = useState<Hero[]>([])
  useEffect(() => {
    setHeroes(JSON.parse(JSON.stringify(heroesData)))
  }, [])

  return (
    <>
      <IntroSection>
        <IntroTextContainer>
          <h1>Meet our Superheroes</h1>
          <p>
            We believe that everyone has the power to be a hero. Our SDG
            Superheroes are inspired by the 17 Sustainable Development Goals
            (SDGs) and represent the qualities, actions, and values needed to
            create a better future for all. Each hero embodies a unique mission
            — from fighting inequality to protecting the planet — and they’re
            here to inspire you to take action.
          </p>
        </IntroTextContainer>
        <PillButton title="Find your Superhero" link={'/quiz'} />
      </IntroSection>
      <SuperHeroGrid>
        {heroes.map((hero) => (
          <HeroCard
            key={hero.id}
            // to={`/superhero/${hero.id}`}
            // Temporary disable the link
            // TODO - Restore the link when the background image of the heroes are ready
            to=""
            $sdg={hero.id.toString()}
          >
            <HeroImageContainer>
              <HeroImage
                src={`/images/heroes/SDG_${hero.id}.png`}
                alt={hero.name}
              />
            </HeroImageContainer>
            <HeroTitle>{hero.name}</HeroTitle>
            <HeroSubtitle>
              SDG {hero.id} {hero.sdg}
            </HeroSubtitle>
            <HeroDescriptionContainer>
              <HeroDescription>{hero.description}</HeroDescription>
            </HeroDescriptionContainer>
          </HeroCard>
        ))}
      </SuperHeroGrid>
    </>
  )
}

const IntroSection = styled.div`
  padding: 120px 64px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background: radial-gradient(
    ellipse 150% 150% at bottom,
    white 30%,
    ${(props) => props.theme.colors['primary-500']} 70%
  );
  @media (max-width: ${breakpoints.desktop}px) {
    padding: 120px 24px 40px;
  }
`
const IntroTextContainer = styled.div`
  max-width: 864px;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
  @media (max-width: ${breakpoints.desktop}px) {
    max-width: auto;
  }
`
const SuperHeroGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  gap: 32px;
  place-items: center;
  padding: 0 64px;
  @media (max-width: ${breakpoints.desktop}px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 24px;
    gap: 17px;
  }
}
`
const HeroImageContainer = styled.div`
  width: auto;
  height: 400px;
  overflow: hidden;
  position: relative;
  @media (max-width: ${breakpoints.desktop}px) {
    height: 216px;
  }
`
const HeroImage = styled.img`
  height: 140%;
  width: 100%;
  object-fit: cover;
  object-position: top;
  transition: all 0.3s ease;
`
const HeroCard = styled(NavLink).attrs<{ $sdg?: string }>((props) => ({
  $sdg: props.$sdg,
}))<{ theme: { colors: { [key: string]: string } } }>`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 8px;
  text-decoration: none;
  color: black;  
  &:hover {
    ${HeroImage} {
      filter: drop-shadow(
      0 0 10px ${(props) => props.theme.colors[`sdg${props.$sdg}-500`]});
      transform: translateY(-10px);
    }
    
`
const HeroTitle = styled.h4`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 18px;
  }
`
const HeroSubtitle = styled.h6`
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 11px;
  }
`
const HeroDescriptionContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`
const HeroDescription = styled.p`
  line-height: 1.5;
  @media (max-width: ${breakpoints.desktop}px) {
    font-size: 8px;
  }
`

export default SuperheroesPage
